/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import HotelState from '../state/HotelState'
import HotelEvent from '../../event/HotelEvent'

class HotelStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new HotelState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case HotelEvent.fetchOne:
        return new HotelState().mergeModel(payload.hotel)
      case HotelEvent.onEdit:
        return state.set(payload.name, payload.value)
      default:
        return state
    }
  }
}

export default new HotelStore()
